import {
  SEE_POPUP_FAIL,
  SEE_POPUP_RESET,
  SEE_POPUP_START,
  SEE_POPUP_SUCCESS,
} from "./constants";
import {SeePopupActions, SeePopupState} from "./types";

const initialState: SeePopupState = {
  loading: false,
  data: false,
  error: undefined,
}

const reducer = (
  state = initialState,
  action: SeePopupActions,
): SeePopupState => {
  switch (action.type) {
    case SEE_POPUP_START:
      return {
        ...initialState,
        loading: true,
      }
    case SEE_POPUP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case SEE_POPUP_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      }
    case SEE_POPUP_RESET:
      return {
        ...initialState,
      }
    default:
      return state;
  }
}

export default reducer;
